/**
 * Issue #711 — suggestions for the new-look scorecard's Opposition, Your
 * team and Competition fields, built from the player's own matches.
 *
 * Most recent `match_date` first (ISO dates compare as text). Same-date
 * order is unspecified: the input only guarantees it is sorted by date. Values that differ only in
 * case or spacing are one entry, shown as the most recent spelling. The
 * stored strings come back unchanged. A planned fixture is never offered
 * (D231), and blank values are dropped.
 */
export function recentDistinct(matches, field) {
  const rows = (matches || []).filter((m) => m && m.status !== "planned");
  const newestFirst = rows
    .slice()
    .reverse()
    .sort((a, b) => {
      const da = a.match_date || "";
      const db = b.match_date || "";
      return da < db ? 1 : da > db ? -1 : 0;
    });
  const seen = new Set();
  const out = [];
  for (const m of newestFirst) {
    const value = m[field];
    if (typeof value !== "string" || value.trim() === "") continue;
    const key = value.normalize("NFC").trim().replace(/\s+/g, " ").toLocaleLowerCase("en-NZ");
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(value);
  }
  return out;
}
